import { IS_USER_AUTH_GETTERS } from "@/store/storeConstants"

export default {
    [IS_USER_AUTH_GETTERS]:(state)=>{
        return !!state.token
    }
}